
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./on-call-modal.cjs.production.min.js')
} else {
  module.exports = require('./on-call-modal.cjs.development.js')
}
